// removed by extract-text-webpack-plugin
module.exports = {"top_providers":"top_providers","top_providers_header":"top_providers_header","top_providers_subtitle":"top_providers_subtitle","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/TopProviders/style.scss
// module id = 1367
// module chunks = 0